module.exports = __webpack_public_path__ + "media/images/video_akaire-6b5800fd.png";